<template>
    <div class="mask" v-if="showFlag" >
       <div class="calendar border flex-col"  >
           <div class="flex  flex-space-between padding-m" style="height: 30px;">
               <div class="font-bold">日历</div>
               <div class="font-s pointer flex flex-center-cz">
                   <img class="icon" src="@/assets/images/guanbi.png" @click="close"/>
               </div>
           </div>
           <vue-custom-scrollbar class="padding-l ">
                <FullCalendar :options='calendarOptions' />
           </vue-custom-scrollbar>
           <div class="msg-info-sjx"></div>
       </div>
        <popup-menu ref="opMenu" :menuData="opMenuData"  @menuClick="opMenuClick"></popup-menu>
    </div>
 
 
 </template>
 
 
 <script>
 
 import MySwitch from '@/components/switch/Switch.vue'
 import {savePlan,queryPlan, deletePlan,listPlan} from '@/api/api.js';
 import { getJsDate} from "@/utils/dateUtils.js"
 import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import zhCN from '@fullcalendar/core/locales/zh-cn';
import interactionPlugin from '@fullcalendar/interaction'; // for selectable
import { Solar } from 'lunar-javascript'
import { getNowDate } from '../../utils/dateUtils';
import PopupMenu from '@/components/popupMenu/PopupMenu' 

 export default {
     name: 'Calendar',
     props: {
         show: {default: false},
     },
     components:{FullCalendar,PopupMenu},
     created() {
     },
 
     watch: {
       show(val) {
           this.showFlag = val
           if (val == true) {
             console.log("load");
             this.load();
           } 
       },
     },
     data() {
        let that = this
         return {
            inputValue:"",
            selectDate:"",
            opMenuData: [
                {id:'add',name:'编辑'},
                {id:'del',name:'删除'},                   
            ],            
            calendarOptions: {
                plugins: [interactionPlugin,dayGridPlugin],
                initialView: 'dayGridMonth',
                //weekends: false,
                selectable: true,
                locale: zhCN,         
                events: [],
                views: {
                    dayGridMonth: {
                        // ✅ 重写日期单元格，追加农历
                        dayCellContent: (info) => {
                        const solar = Solar.fromDate(info.date)
                            const lunar = solar.getLunar()
                            // 初一显示月份（如"正月"），其余显示日子（如"初八"）
                            const lunarText =
                                lunar.getDay() === 1
                                ? lunar.getMonthInChinese() + '月'
                                : lunar.getDayInChinese()
                            return {
                                html: `<span class="fc-day-number">${info.date.getDate()}</span>
                                    <span class="fc-lunar-text">${lunarText}</span>`
                            }
                        }
                    }
                    },
                    dateClick: async function(info) {
                        await that.getTitle(info.dateStr);
                        that.selectDate = info.dateStr
                        //console.log("info===", info.jsEvent)
                        that.$refs.opMenu.show(info.jsEvent);//
                        //alert('点击: ' + info.dateStr);
                    }
                },

             filter:{notShowFinish: true},
             showFlag: false,
             tableData:[]
 
         }
     },
 
     methods: {
        opMenuClick(id) {
            if (id == "add") {
                this.$showInputBox({
                    caption: "日程",
                    inputValue: this.inputValue,
                    callback: (data) => {
                        let param = {
                            planDate: this.selectDate,
                            content: data
                        }
                        this.save(param)
                        this.$closeInputBox();   
                    }
                })    
            }
            if (id == "del") {
                deletePlan(getJsDate(this.selectDate)).then((res) => {
                    this.load()
                    this.$closeLoading();
                })
            }
 
        },  
        
        // del(item) {
        //     this.$showMsgBox({
        //         caption:"询问",
        //         msg: '确定要删除吗？',
        //         callback:(data) => {
        //             if (data == "yes") {
        //                 this.tableData = this.tableData.filter(d=>d.id != item.id);
        //                 this.$showLoading();
        //                 deletePlan(item.id).then((res) => {
        //                     this.$closeLoading();
        //                 })
        //             } 
        //         }
        //     })

        // },
        load() {
            listPlan().then((res) => {
                console.log(res);
                if (res.data.success == true) {
                    let data = res.data.result.records;
                    let eventData = [];
                    data.forEach(item => {
                        item.planDate = getJsDate(item.planDate)      
                        eventData.push({title: item.content, start: item.planDate})                 
                    });
                    this.tableData = data;
                    this.eventData = eventData
                    this.$set(this.calendarOptions, 'events', this.eventData)
                    //console.log("eventData==", this.eventData)
                    this.$forceUpdate()
                }
             });
         },
         async getTitle(param) {
            let result = ''
            await queryPlan(param).then((res) => {
                console.log(res.data);
                if (res.data.success == true && res.data.result) {
                    result = res.data.result.content
                } 
                this.inputValue = result;
            });
         },         
         save(param) {
            savePlan(param).then((res) => {
                console.log(res.data);
                if (res.data.success == true) {
                    this.load()
                } else {
                    this.$showToast({msg: res.data.message });       
                }
            });
         },
        //  contentBlur(item) {
        //     let param = {
        //         id : item.id,
        //         content: item.content
        //     }
        //     editTodo(param).then((res) => {
        //         if (res.data.success == false) {
        //             this.$showToast({msg: res.data.message });       
        //         }
        //     });

        //  },
        //  tagBlur(item) {
        //     let param = {
        //         id : item.id,
        //         tag: item.tag
        //     }
        //     editTodo(param).then((res) => {
        //         if (res.data.success == false) {
        //             this.$showToast({msg: res.data.message });       
        //         }
        //     });
        //  },
         close() {
           this.$emit("close")
         }
 
     }
 }
 </script>
 
 
 <style scoped>
   .calendar {
     position: absolute;
     background-color: #fff;
     border-radius: 10px;
     top:50px;
     bottom: 50px;
     left: 50px;
     right: 50px;
     z-index: 999;
     display: flex;
     flex-direction: column;
     padding: 10px;
   }
   .msg-info-sjx {
     transform: rotate(45deg);
     top: -7px;
     right: 180px;
     width: 10px;
     height: 10px;
     position: absolute;
     border-left: 1px solid rgba(0, 0, 0, .2);
     border-top: 1px solid rgba(0, 0, 0, .2);
     z-index: 9999;
     background-color: #fff;
   }
 

   .body {
    height: 510px;
   }
   .icon1 {
     width: 20px;
     height: 20px;
   }
 
   .icon {
     width: 22px;
     height: 22px;
   }
 
 
 </style>
 


// WEBPACK FOOTER //
// src/modules/calendar/Calendar.vue